export default {
  mapLeftClick: {
    placeInfo: 'Detalhes do local',
    placeInsidePolygon: 'Local dentro do polígono',
    polygonArea: 'Área do polígono',
    copyLnglat: 'Copiar lng, lat',
    copyLatlng: 'Copiar lat, lng',
    directionsToClickedPoint: 'Rota para o local clicado',
    lnglatCopied: 'Longitude e latitude copiadas',
    latlngCopied: 'Latitude e longitude copiadas'
  }
}
